module.exports = __webpack_public_path__ + "assets/formosa.cba919e9.svg";